import { Component, Input, ContentChildren, forwardRef } from '@angular/core';

@Component({
  selector: 'menu-item',
  template: `<ng-container></ng-container>`
})
// eslint-disable-next-line @angular-eslint/component-class-suffix -- Preserve the MenuItem type imported by existing navigation consumers.
export class MenuItem {
	@Input() id: string;
	@Input() icon: string;
	@Input() title: string;
	@Input() url: string;
	@Input() queryParams: { [key: string]: string };
	@Input() target: '_blank' | '_parent' | '_self' | '_top' = '_self';
	@Input() disabled = false;
	@Input() toolTip = '';
	@Input() badge: string | number;
	@Input() badgeClass = 'kt-badge--success';

	get accessibleLabel(): string {
		return this.hasBadge ? `${this.title}, ${this.badge}` : this.title;
	}

	get hasBadge(): boolean {
		return this.badge !== null && this.badge !== undefined && this.badge !== '';
	}

	@ContentChildren(forwardRef(() => MenuItem))

	private _subItems: MenuItem[];

	get subItems(): MenuItem[] {
		return this._subItems.filter(col => col !== this);
	}
  get isRouterLink() {
    return /^\/(?!api\/)/.test(this.url);
  }

  get isHref() {
    return !this.isRouterLink;
  }
}
